import graphql__72ae9f6858ba206246db from "./__generated__/PageSectionSidebarParticipativeModulesList_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import { useSidebarSectionTitle } from "./useSidebarSectionTitle";
import ParticipativeModuleCard from "../ParticipativeModule/ParticipativeModuleCard";

const SECTION_CLASS_NAME =
  "page-section page-section-sidebar-participative-modules-list card box " +
  "page-section-sidebar-box border-radius-bottom";

const PageSectionSidebarParticipativeModulesList = props => {
  const pageSection = useFragment(
    PageSectionSidebarParticipativeModulesList_pageSection,
    props.pageSection
  );

  const { participativeModules } = pageSection;
  const { title } = useSidebarSectionTitle({ pageSection });

  return (
    <div className={SECTION_CLASS_NAME}>
      {title}

      <div className="card-body">
        <div className="row cards-row">
          {participativeModules.map(participativeModule => (
            <div key={participativeModule.id} className="col-12">
              <ParticipativeModuleCard participativeModule={participativeModule} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const PageSectionSidebarParticipativeModulesList_pageSection = graphql__72ae9f6858ba206246db;

export default PageSectionSidebarParticipativeModulesList;
